module.exports = __webpack_public_path__ + "img/position-no-change.49eaaf1c.svg";